<template>
  <div style="display: inline-block;">
    <el-dropdown @command="handleImageCirculation">
      <el-button class="temp_plain">
        图片操作<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="index" v-for="(item, index) in typeList">{{item[0]}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog class="main_dialog" :show-close="false" :title="typeList[imageType][0]" :width="imageType == 'template_task' ? '800px' : '594px'" :visible.sync="dialogImageVisible" append-to-body>
      <div class="select_len">已选择{{ $route.path.includes('/detail') ? imageType == 'template_task' ? ruleForm?.file_ids?.length : ruleForm?.images?.length : imageList.length }}张图片</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" hide-required-asterisk label-width="106px" @submit.native.prevent>
        <div v-if="imageType == 'image_image'">
          <!-- <el-form-item label="尺寸比例：" prop="size">
            <el-select v-model="ruleForm.size" placeholder="请选择">
              <el-option label="1024 * 1024" value="1024*1024"></el-option>
              <el-option label="1280 * 720" value="1280*720"></el-option>
              <el-option label="720 * 1280" value="720*1280"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="图片相似度：" prop="ref_strength">
            <el-slider v-model="ruleForm.ref_strength" :min="0" :max="1" :step="0.1" show-input :show-input-controls="false"></el-slider>
          </el-form-item>
          <el-form-item label="生成数量：" prop="num">
            <el-radio-group v-model="ruleForm.num" size="mini">
              <el-radio border :label="item" v-for="item in 4">{{item}}张</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="版本：" prop="version">
            <el-radio-group v-model="ruleForm.version" size="mini">
              <el-radio label="1.0">1.0</el-radio>
              <el-radio label="2.0">2.0</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-else-if="imageType == 'graph_fission'">
          <el-form-item label="图片相似度：" prop="ref_strength">
            <el-slider v-model="ruleForm.ref_strength" :min="0" :max="1" :step="0.1" show-input :show-input-controls="false"></el-slider>
          </el-form-item>
          <el-form-item label="生成数量：" prop="num">
            <el-radio-group v-model="ruleForm.num" size="mini">
              <el-radio border :label="item" v-for="item in 4">{{item}}张</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="版本：" prop="version">
            <el-radio-group v-model="ruleForm.version" size="mini">
              <el-radio label="1.0">平铺</el-radio>
              <el-radio label="2.0">模特</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-else-if="imageType == 'template_task'">
          <el-form-item label="店铺：" prop="shop_id">
            <el-select v-model="ruleForm.shop_id" placeholder="请选择店铺">
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-tabs
            v-model="searchTemp.category_id"
            @tab-click="getTemplateList"
            class="classify_tabs"
          >
            <el-tab-pane
              :label="item.name"
              :name="item.id + ''"
              v-for="item in classifyList"
            ></el-tab-pane>
          </el-tabs>

          <el-table
            :data="tempTableData"
            @selection-change="handleSelectionChange"
            class="main_d_table"
          >
            <el-table-column
              type="selection"
              width="55"
            />
            <el-table-column prop="date" label="素材">
              <template slot-scope="scope">
                <div class="table_sucai">
                  <img :src="scope.row.images[0].image_url" alt="" />
                  <div>
                    <div class="table_sucai_title">
                      {{ scope.row.name }}
                      <span>{{
                        scope.row.type == 1 ? "单印花" : "多印花"
                      }}</span>
                    </div>
                    <div class="table_sucai_item">
                      印刷大小：
                      <div style="width: 200px; display: flex; flex-wrap: wrap">
                        <div v-for="size in scope.row.sizes">
                          <div
                            style="margin-right: 4px"
                            v-for="cutpiece in size.cutpieces"
                          >
                            {{ size.size }}-{{ cutpiece.name }}:{{
                              cutpiece.width
                            }}*{{ cutpiece.height }}cm
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="table_sucai_item">
                      尺码规格：
                      <p v-for="size in scope.row.sizes">{{ size.size }}</p>
                    </div>
                    <div class="table_sucai_item">
                      颜色规格：<span
                        v-for="color in scope.row.colors"
                        :style="{ background: color.hex_value }"
                      ></span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="轮播图">
              <template slot-scope="scope">
                <div class="table_banner">
                  <img
                    v-for="item in scope.row.images"
                    :src="item.image_url"
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else-if="imageType == 'upscaled'">
          <el-form-item label="放大倍数：" prop="version">
            <el-radio-group v-model="ruleForm.version" size="mini">
              <el-radio border :label="item" v-for="item in 5">{{item}}X</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-else-if="imageType == 'extract_print'">
          <el-form-item label="版本：" prop="version">
            <el-radio-group v-model="ruleForm.version" size="mini" style="margin-top: 10px;">
              <el-radio label="1.0">本地</el-radio>
              <el-radio label="2.0">智能</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-else-if="imageType == 'caption'">
          <el-form-item label="语言：" prop="version">
            <el-radio-group v-model="ruleForm.version" size="mini" style="margin-top: 10px;">
              <el-radio label="en">英语</el-radio>
              <el-radio label="th">泰语</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="imageType == 'infringement_detection'">
          <el-form-item label="检测范围：" prop="content">
            <el-input
              ref="editinput"
              type="textarea"
              v-model="ruleForm.content"
              autosize
              :readonly="!isEditScope"
            ></el-input>
            <el-button type="primary" size="mini" @click="editInfringScope">{{isEditScope ? '确定' : '修改'}}</el-button>
            <el-button v-if="isEditScope" size="mini" @click="getInfringScope">取消</el-button>
          </el-form-item>
          <el-checkbox ref="noticeCheckRef" :value="noticeCheck" @change="noticeChange">侵权风险过滤功能使用须知</el-checkbox>
        </div>
        <!-- <div v-else-if="imageType == 'caption' || imageType == 'infringement_detection'" v-loading="modelLoading">
          <el-form-item label="语言模型：" prop="models" v-if="imageType == 'caption'">
            <el-input v-model="ruleForm.language" readonly style="width: 140px;"></el-input>
          </el-form-item>
          <el-form-item label="视觉模型：" prop="models">
            <el-input v-model="ruleForm.models" readonly style="width: 140px;"></el-input>
          </el-form-item>
        </div> -->
      </el-form>
      <div style="text-align: right;">
        <el-button class="dialog_confirm" size="small" @click="confirmOperate">
          立 即 生 成 
          <span class="expend_num" v-if="beanNum">(消耗{{beanNum}}积分)</span>
        </el-button>
        <el-button class="dialog_cancel" size="small" @click="dialogImageVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { shopGetList } from '@/api/shop'
import { templateTaskCreate } from "@/api/templateTask";
import { categoryGetList, templateGetList } from "@/api/template";
import { aiCreate, aiGetModellist, aiGetInfringScope, aiEditInfringScope, aiGetBeansConfig } from '@/api/imgAndText'
export default {
  name: "ImageOperate",
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      typeList: {
        rembg: ['一键抠图', 'matting'],
        image_image: ['图裂变', 'figures'],
        graph_fission: ['图裂变3.0', 'figures3'],
        upscaled: ['图片放大', 'magnify'],
        template_task: ['商品套图', 'setPicture'],
        extract_print: ['印花提取', 'printExtract'],
        caption: ['标题提取', 'extractTitle'],
        infringement_detection: ['侵权检测', 'infringement'],
      },
      imageType: 'rembg',
      dialogImageVisible: false,
      ruleForm: {},
      rules: {},
      shopList: [],
      classifyList: [{ name: "全部", id: "" }],
      searchTemp: {
        type: "1",
        category_id: "",
        page: 1,
        limit: 10000000,
      },
      tempTableData: [],
      modelList: {},
      modelLoading: false,
      
      isEditScope: false,
      noticeCheck: false,

      beansConfig: null,
    }
  },
  computed: {
    beanNum() {
      let initial = this.beansConfig?.beans
      let iscoutimg = this.beansConfig?.per_image
      if(iscoutimg) {
        let imglen = this.imageType == 'template_task' ? this.ruleForm.file_ids.length : this.ruleForm.images.length
        initial = imglen * initial
      }

      if(this.imageType == 'image_image' || this.imageType == 'graph_fission') {
        initial = initial * this.ruleForm.num
      }

      return initial || 0
    }
  },
  methods:{
    handleImageCirculation(command) {
      aiGetBeansConfig(command).then(res => {
        this.beansConfig = res.data
        this.imageType = command
        this.ruleForm = {}
        // 置空
        if(command == 'image_image') {
          this.$set(this.ruleForm, 'images', [])
          this.$set(this.ruleForm, 'size', '1024*1024')
          this.$set(this.ruleForm, 'ref_strength', 0.4)
          this.$set(this.ruleForm, 'num', 1)
          this.$set(this.ruleForm, 'version', '1.0')
        }else if(command == 'graph_fission') {
          this.$set(this.ruleForm, 'images', [])
          this.$set(this.ruleForm, 'ref_strength', 0.4)
          this.$set(this.ruleForm, 'num', 1)
          this.$set(this.ruleForm, 'version', '1.0')
        }else if(command == 'template_task') {
          // 商品套图  好像跟非商品套图的一样了，之后再看看改一下
          this.classifyList = [{ name: "全部", id: "" }]
          this.searchTemp.category_id = ''
          this.searchTemp.page = 1
          this.getShopList()
          this.getCategoryList()
          this.getTemplateList()
          this.$set(this.ruleForm, 'template_ids', [])
          this.$set(this.ruleForm, 'shop_id', '')
          if(this.$route.path.includes('/detail')) {
            // 工具详情页
            this.$set(this.ruleForm, 'source', 'url')
            let position = []
            this.imageList.forEach(item => {
              if(item.orichecked) {
                // 原图
                position.push([{url: item.prompt, image_title: item.image_title}])
              }
              item.image_urls.forEach((iten, indey) => {
                if(iten.checked) {
                  position.push([{url: iten.result_image_url || iten.url, image_title: item.image_title}])
                }
              })
            })
            this.$set(this.ruleForm, 'file_ids', position)
          } else if(this.$route.path.includes('/material')) {
            // 素材页
            this.$set(this.ruleForm, 'source', 'url')
            let position = []
            this.imageList.forEach(item => {
              position.push([item.url])
            })
            this.$set(this.ruleForm, 'file_ids', position)
          }else {
            // 采集页
            this.$set(this.ruleForm, 'source', 'capture')
            this.$set(this.ruleForm, 'file_ids', this.imageList.map(item => [item.id]))
          }  
        }else if(command == 'upscaled') {
          this.$set(this.ruleForm, 'images', [])
          this.$set(this.ruleForm, 'version', 1)
        } else if(command == 'extract_print') {
          this.$set(this.ruleForm, 'images', [])
          this.$set(this.ruleForm, 'version', '1.0')
        } else if(command == 'caption') {
          this.$set(this.ruleForm, 'images', [])
          this.$set(this.ruleForm, 'version', 'en')
        } else if(command == 'infringement_detection') {
          this.$set(this.ruleForm, 'images', [])
          this.$set(this.ruleForm, 'content', '')
          this.getInfringScope()
        }
        // 赋值
        if(command != 'template_task') {
          // 非商品套图
          if(this.$route.path.includes('/detail')) {
            let position = []
            this.imageList.forEach(item => {
              if(item.orichecked) {
                // 原图
                position.push({url: item.prompt, image_title: item.image_title})
              }
              item.image_urls.forEach((iten, indey) => {
                if(iten.checked) {
                  position.push({url: iten.result_image_url || iten.url, image_title: item.image_title})
                }
              })
              
            })
            this.$set(this.ruleForm, 'images', position)
          } else if(this.$route.path.includes('/material')) {
            let position = []
            this.imageList.forEach(item => {
              position.push({url: item.url, image_title: item.image_title})
            })
            this.$set(this.ruleForm, 'images', position)
          }else {
            this.$set(this.ruleForm, 'images', this.imageList.map(item => {return {url: item.image_url, image_title: item.title}}))
          }
          this.$set(this.ruleForm, 'type', command)
        }
        this.dialogImageVisible = true
      })
    },
    handleInputInt(val) {
      this.ruleForm.version = Math.round(val)
    },
    handleSelectionChange(val) {
      this.ruleForm.template_ids = val.map((item) => {
        return item.id;
      });
    },
    noticeChange(val) {
      if(!this.$refs.noticeCheckRef.value) {
        let text = `在您使用本网站提供的侵权风险过滤服务前，请您仔细阅读本声明的所有条款，您一旦开始使用该服务，即表明您无条件地接受本免责声明，您应遵守本声明和相关法律的规定。\n1. 我们提供的侵权风险过滤服务（包括但不限于文字、图片等内容的侵权风险分析）均基于自动化算法及公开数据，结果仅供参考，不构成任何形式的法律意见或专业建议。\n2. 本服务无法保证结果的绝对准确性、完整性或时效性，可能存在漏判、误判或因法律法规变化导致的偏差。\n3. 您需自行判断过滤检测结果的适用性，并承担因依赖该结果而产生的全部风险。对于您依据本服务做出的任何行为（如内容发布、下架、商业决策等），我们不承担法律责任。\n4. 如您不同意本声明内容，应立即停止使用侵权风险过滤服务。继续使用视为接受全部条款。\n生成页面建议提示内容：检测结果仅供参考，不构成任何形式的法律意见或专业建议。您应做出独立的判断，本网站对您依据本服务做出的决策不承担责任。`
        this.$confirm(text, '侵权风险检测功能使用须知', {
          customClass: 'notice_msgbox',
          confirmButtonText: '我已知晓，同意',
          cancelButtonText: '取消',
        }).then(() => {
          this.noticeCheck = true
        }).catch(() => {
        });
      }else {
        this.noticeCheck = false
      }
    },
    editInfringScope() {
      if(this.isEditScope) {
        aiEditInfringScope({content: this.ruleForm.content}).then(res => {
          this.$message.success('修改成功')
          this.isEditScope = false
        })
      }else {
        this.isEditScope = true
        this.$refs.editinput.focus()
      }
    },
    confirmOperate() {
      if(!this.noticeCheck && this.imageType == 'infringement_detection') {
        this.noticeChange();
        return;
      }
      let apimethod = this.imageType == 'template_task' ? templateTaskCreate : aiCreate
      apimethod(this.ruleForm).then(res=>{
        this.$store.dispatch("USER_INFO");
        this.$message({
          type: 'success',
          dangerouslyUseHTMLString: true,
          message: `创建任务成功，<a style="text-decoration: underline;text-underline-position: under;" href="/toolbox/${this.typeList[this.imageType][1]}/detail?id=${this.imageType == 'template_task' ? res.data.task_ids[0] : res.data.task_id}">前往查看详情</a>`
        })
        this.dialogImageVisible = false;
      })
    },
    getmodelList() {
      this.modelLoading = true
      aiGetModellist().then(res => {
        this.modelList = res.data
        this.modelLoading = false
      })
    },
    getShopList() {
      shopGetList({page: 1, limit: 500, status: 1}).then(res => {
        this.shopList = res.data.data
      })
    },
    getCategoryList() {
      categoryGetList({ page: 1, limit: 500 }).then((res) => {
        this.classifyList = this.classifyList.concat(res.data);
      });
    },
    getTemplateList() {
      templateGetList(this.searchTemp).then((res) => {
        if (res.code == 200) {
          // this.select_imgs=[];
          // this.select_img_ids=[];
          // this.print_names = [];
          // this.multipleSelection = [];
          this.tempTableData = res.data.data;
        }
      });
    },
    getInfringScope() {
      aiGetInfringScope().then(res => {
        this.ruleForm.content = res.data.content
        this.isEditScope = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.temp_plain {
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  width: 130px;
  text-align: center;
  padding: 0;
  margin-left: 16px;
  border: 1px solid #132632;
  color: #132632;
  background: transparent;
  height: 42px;
  line-height: 42px;
}
.select_len {
  color: #3186E5;
  margin-bottom: 16px;
}
.classify_tabs {
  /deep/ .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
    .el-tabs__active-bar {
      // background: #acaf0b;
    }
    .el-tabs__item {
      // color: #e0e0e0;
      font-size: 16px;
      &.is-active {
        // color: #ffffff;
      }
      &:nth-child(2) {
        padding-left: 8px;
      }
    }
  }
}
.table_sucai {
  display: flex;
  width: max-content;
  img {
    max-width: 112px;
    max-height: 112px;
    margin-right: 16px;
    object-fit: cover;
    align-self: center;
  }
  .table_sucai_title {
    font-size: 16px;
    span {
      display: inline-block;
      font-size: 12px;
      border-radius: 18px;
      background: #3b4663;
      color: #ffffff;
      width: 56px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      margin-left: 8px;
    }
  }
  .table_sucai_item {
    display: flex;
    color: #737373;
    font-size: 12px;
    p {
      margin-right: 4px;
    }
    span {
      display: inline-block;
      align-self: center;
      width: 12px;
      height: 12px;
      margin-right: 4px;
      border: 1px solid #ededed;
    }
  }
}
.table_banner {
  width: 70%;
  img {
    width: 54px;
    height: 54px;
    margin-right: 4px;
    margin-bottom: 5px;
    object-fit: cover;
    vertical-align: middle;
  }
}
.dialog_confirm {
  width: fit-content !important;
}
</style>
<style lang="scss">
.notice_msgbox {
  width: 30%;
  white-space: pre-line;
  .el-message-box__btns .el-button:nth-child(2) {
    width: 120px;
  }
}
</style>